'use strict'

var pageNewsSheet = pageNewsSheet || {}
var $ = jQuery

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
pageNewsSheet.init = function () {
  pageNewsSheet.placement()
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(pageNewsSheet.init)

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
// Animate content in Page type
pageNewsSheet.placement = function () {

  // console.log('pageNewsSheet');

  var pageNews = $('.page--news-sheet')
  var newsAnomymous = pageNews.find('.news-sheet--anonymous')
  var newsFull = pageNews.find('.news-sheet--full')
  var newsPremium = pageNews.find('.news-sheet--premium')
  var fieldType = newsAnomymous.find('.field--field-news-type')
  var fieldTypeFull = newsFull.find('.field--field-news-type')
  var fieldTypePremium = newsPremium.find('.field--field-news-type')

  var creationDate = pageNews.find(
    '.block--starter-views-block--content-publication-date-block-created-date')

  fieldType.appendTo(creationDate)
  fieldTypeFull.appendTo(creationDate)
  fieldTypePremium.appendTo(creationDate)

  setTimeout(function () {
    fieldType.addClass('show')
    fieldTypeFull.addClass('show')
    fieldTypePremium.addClass('show')
  }, 400)

}
